// import Vue from 'vue'
import Vuex from 'vuex'

// Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login: false,
    language: 'ja',
    organization: null,
    userData: null,
    role: 'user',
    superadmin: false,
    score: 'age'
  },
  mutations: {
    mutateLogin (state, status) {
      state.login = status
    },
    mutateLanguage (state, payload) {
      state.language = payload
    },
    mutateOrganization (state, payload) {
      state.organization = payload
    },
    mutateRole (state, payload) {
      state.role = payload
    },
    mutateSuperadmin (state, payload) {
      state.superadmin = payload
    },
    mutateUserData (state, payload) {
      state.userData = payload
    },
    mutateScore (state, payload) {
      state.score = payload
    }
  },
  actions: {
    commitLogin (context, payload) {
      context.commit('mutateLogin', true)
    },
    commitLanguage (context, payload) {
      context.commit('mutateLanguage', payload)
    },
    commitOrganization (context, payload) {
      context.commit('mutateOrganization', payload)
    },
    commitRole (context, payload) {
      context.commit('mutateRole', payload)
    },
    commitSuperadmin (context, payload) {
      context.commit('mutateSuperadmin', payload)
    },
    commitUserData (context, payload) {
      context.commit('mutateUserData', payload)
    },
    commitScore (context, payload) {
      context.commit('mutateScore', payload)
    }
  },
  modules: {}
})
